import { makeAutoObservable, observable, action, runInAction } from "mobx";
import agent from "../api/agent";
import { RootStore } from "./rootStore";
import { toast } from "react-toastify";
import { showError } from "../util/errorTypeEnumsOptions";

export default class CertificateStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  @observable certificates: any[] = [];
  @observable btCreateCertificate = false;
  @observable loadData = false;

  @action changeStatebtCreateCertificate = () => {
    this.btCreateCertificate = !this.btCreateCertificate;
  };

  @action getCertificates = async () => {
    try {
      const cer = await agent.Certificates.getCertificates();
      runInAction(() => {
        this.certificates = cer;
      });
    } catch (error) {
      showError(error);
    }
    runInAction(() => {
      this.loadData = true;
    });
  };

  @action postCertificate = async (certificateFrom: any) => {
    try {
      await agent.Certificates.postCertificate(certificateFrom);
      toast.success("Certificado guardado correctamente");
      this.rootStore.modalStore.closeModal();
      this.getCertificates();
    } catch (error) {
      showError(error);
    }
    this.changeStatebtCreateCertificate();
  };

  @action delCertificate = async (id: string) => {
    try {
      const del = await agent.Certificates.delCertificate(id);
      if (del) {
        this.rootStore.modalStore.closeModal();
        this.getCertificates();
      } else {
        toast.error(
          "UPS! Ocurrio un error eliminando el certificado, vuelve a intentarlo más tarde"
        );
      }
    } catch (error) {
      showError(error);
    }
  };
}
